// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"9d16ff96","404":"de706ee4"}[chunkId] + ".chunk.css";
};